import {
    getEnvironment,
    isMSI,
} from '@uipath/portal-shell-util';

import { getEnvConfigField } from './EnvironmentUtil';
import { GlobalPropsInstanceResolver } from './globalProps/globalPropsInstanceResolver';
import Logger from './logger/logger';
import {
    getAccountName,
    getBaseUrl,
} from './urlHelper';

export function getOrganizationStandardUrl({
    shouldIncludeAccountNameOnK8s = false,
    shouldUseDefaultBaseUrl = false,
    shouldAlwaysExcludeAccountName = false,
} = {},
) {
    let organizationStandardUrl = GlobalPropsInstanceResolver.Instance?.devProperties?.organizationStandardUrl ?? '';
    if (!organizationStandardUrl && GlobalPropsInstanceResolver.Instance?.devProperties?.mode !== 'dev-cloud') {
        organizationStandardUrl = getBaseUrl();

        if (isMSI()) {
            Logger.debug('orgStandardUrl', 'base url msi: ' + organizationStandardUrl);
            return organizationStandardUrl;
        }

        const isLocalOrgStandardUrl = organizationStandardUrl?.includes('localhost:') || organizationStandardUrl?.includes('127.0.0.1:');
        if (shouldUseDefaultBaseUrl && isLocalOrgStandardUrl) {
            organizationStandardUrl = getEnvConfigField('DEFAULT_BASE_URL');
        }

        const accountName = getAccountName();

        if (organizationStandardUrl
            && accountName
            && (shouldIncludeAccountNameOnK8s || getEnvironment() !== 'k8s')
            && !shouldAlwaysExcludeAccountName
        ) {
            organizationStandardUrl += `/${accountName}`;
        }
    }
    Logger.debug('orgStandardUrl', organizationStandardUrl, {
        object: {
            shouldIncludeAccountNameOnK8s,
            shouldUseDefaultBaseUrl,
            shouldAlwaysExcludeAccountName,
        },
    });
    return organizationStandardUrl;
}

export function parseOrganizationStandardUrl(organizationStandardUrl: string) {
    const url = organizationStandardUrl ? new URL(organizationStandardUrl) : {
        origin: '',
        pathname: '',
    };
    return {
        baseUrl: url.origin || getBaseUrl(),
        accountName: url.pathname.split('/')[1] || getAccountName(),
    };
}
